import Mapa from "./Components/Mapa";
import MapaMarcador from "./Components/Mapa/MapaMarcador";
import 'react-toastify/dist/ReactToastify.css';
import {BrowserRouter as Router,Routes,Route} from 'react-router-dom';
 
 
function App() {



    return (
    <Router>
        <Routes>
            <Route  path="/mapa/:usuario/:banderaId/:edoId/:municipioId" element={<Mapa/> }  />   
            <Route  path="/marcador/:usuario/:banderaId/:edoId/:municipioId" element={<MapaMarcador/> }  />  
        </Routes>
    </Router>
    );

}

export default App;
